module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_0.63c87ba8.png";